// extracted by mini-css-extract-plugin
export default {"root":"UILibPage_root__NKPx1","block":"UILibPage_block__IMUwe","col":"UILibPage_col__zFk-R","button":"UILibPage_button__YDAE+","iconTable":"UILibPage_iconTable__pgOWw"};